import { render, staticRenderFns } from "./default.vue?vue&type=template&id=a6c34108&"
import script from "./default.vue?vue&type=script&lang=ts&"
export * from "./default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutsHeaderTheHeader: require('/usr/src/nuxt-app/components/layouts/header/TheHeader.vue').default,LayoutsFooterTheFooter: require('/usr/src/nuxt-app/components/layouts/footer/TheFooter.vue').default})
